// Wrapper ADDITIF (LOT 7c §5 — champ Prénom facultatif) : commande sans client
// (aucune fiche Client, aucun téléphone) mais avec un PRÉNOM affiché sur les
// cartes, posé en `client_nom_snapshot` (champ existant du schéma — aucune
// migration). `transactions.ts` reste 0 diff (frontière §6) : ce module compose
// le wrapper existant `createCommandeSansClient` dans UNE transaction Dexie
// (atomique), même pattern maison que les wrappers LOT 2.
import { getDb } from './index';
import { getCurrentTenantId } from './tenant';
import {
  createCommandeSansClient,
  type CreateCommandeSansClientInput,
} from './transactions';

export interface CreateCommandeAvecPrenomInput
  extends CreateCommandeSansClientInput {
  /** Prénom saisi (affichage cartes) — jamais de fiche Client créée. */
  prenom: string;
}

export async function createCommandeSansClientAvecPrenom(
  input: CreateCommandeAvecPrenomInput,
  tenantId: string = getCurrentTenantId(),
): Promise<{ commandeId: number; pizzaIds: number[] }> {
  const db = getDb();
  const { prenom, ...reste } = input;
  return db.transaction('rw', db.commandes, db.commandePizzas, async () => {
    const res = await createCommandeSansClient(reste, tenantId);
    await db.commandes.update(res.commandeId, {
      client_nom_snapshot: prenom,
      updatedAt: Date.now(),
    });
    return res;
  });
}
